<template>
    <span  v-bind:class="classNameContainer">
        <slot></slot>

        <span class="vue-touch-keyboard-holder" v-bind:class="{'openKeyboard': visible}">
            <span :class="'vue-touch-keyboard-holder-inner '+'layout-'+dataLayout">
                <h5 v-if="visible">{{title}} <span class="numb_alert">{{title2}}</span></h5>
                <span class="addpadding" v-if="visible"></span>
                <span class="addpadding" v-if="visible"></span>

              <!-- - - >
                <DatetimepickerBp v-if="( type=='DatetimepickerBp' && readonly=== 'false' && disabled=== 'false' )" :format="format"
                                  v-on:keyup="keyupFn" v-on:keydown="keydownFn" :hasError="hasErrorData" @input="handleInput" :type="'text'" :name="name" :v-validate="validate" :disabled="disabled !== 'false'"
                                  :readonly="readonly !== 'false'" :dataprops="dataprops"
                                  v-bind:placeholder="placeholder" v-bind:className="(hasErrorData)?className+' is-invalid ':className+' '" v-bind:id="id" v-bind:dataid="dataid" @focus="show" v-bind:data-layout="dataLayout" v-model="val" @blur="onblur"
                ></DatetimepickerBp>
              < ! - - -->

                <input  v-if="!( type=='DatetimepickerBp' && readonly=== 'false' && disabled=== 'false' )" v-on:keyup="keyupFn" v-on:keydown="keydownFn" :aria-invalid="hasErrorData" @input="handleInput" :type="type" :name="name" :v-validate="validate" :disabled="disabled !== 'false'"
                       :readonly="readonly !== 'false'" :data-props="dataprops"
                       v-bind:placeholder="placeholder" v-bind:class="className" v-bind:id="id" v-bind:dataid="dataid" @focus="show" v-bind:data-layout="dataLayout" v-model="val" @blur="onblur"/>
                <span class="addpadding" v-if="visible"></span>
                <TouchKeyboardBp :options="options" v-if="visible" :layout="layout" :cancel="hide" :nplus="nplus" :dbplus="dbplus" :accept="accept" :input="input"/>
            </span>
        </span>
    </span>
</template>

<script>
    import i18n from '@/i18n';
    import Helper from '@/helper/Helper';
//    import DatetimepickerBp from "@/components/DatetimepickerBp";
    import TouchKeyboardBp from "@/components/TouchKeyboardBp";

    // v-bind:style="{'display':display}
    // https://medium.com/js-dojo/component-communication-in-vue-js-ca8b591d7efa
    export default {
        name: "InputText",
        mounted() {
            const modul = this;
            this.val = this.value;
            this.$validator = this.$parent.$validator;
            modul.prefix = Helper.getMoneyDefaultDisplayPrefix();
            modul.suffix = Helper.getMoneyDefaultDisplaySuffix();

            modul.$eventBus.$on('nplus', this.nplus);
            modul.$eventBus.$on('dbplus', this.dbplus);
        },
        beforeDestroy() {
            const modul = this;
            modul.$eventBus.$off('nplus');
            modul.$eventBus.$off('dbplus');
        },
        data() {
            return {
                prefix: "",
                suffix: "",
                content: this.value,
                visible: false,
                layout: "normal",
                input: null,
                options: {
                    useKbEvents: true,
                    preventClickEvent: true
                },
                val: "",
                hasErrorData: false
            }
        },
        watch: {
            value: function (newValue, oldValue) {
                this.val = newValue;
//                this.isValid = newValue;
            },
            "hasError": function (newValue, oldValue) {
                this.hasErrorData = !!newValue;
            }
        },

        props: {
            'hasError': {
                type: [Boolean, String,Number],
                default: ''
            },
            name: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: ''
            },
            title: {
                type: String,
                default: ''
            },
            title2: {
                type: String,
                default: ''
            },
            value: {
                type: [Number, String],
                default: '',
            },
            placeholder: {
                type: String,
                default: '',
            },
            dataLayout: {
                type: String,
                default: "normal",
            },
            hasToKeyboard: {
                type: String,
                default: "false",
            },
            className: {
                type: String,
                default: "",
            },
            classNameContainer: {
                type: String,
                default: "",
            },
            disabled: {
                type: String,
                default: "false",
            },
            readonly: {
                type: String,
                default: "false",
            },
            id: {
                type: String,
                default: "false",
            },
            'dataid': {
                type: String,
                default: "false",
            },
            'keys': {
                type: Array,
                default: function () {
                    return ['value']
                }
            },
            'isChange': {
                type: String,
                default: "true",
            },
            'isAccept': {
                type: String,
                default: "false",
            },
            'validate': {
                type: String,
                default: "",
            },
            format: {
                type: String,
                default: 'YYYY-MM-DD', //  h:i:s
            },
            keyup: {
                type: Function,
                default: function (event) {
                }
            },
            keydown: {
                type: Function,
                default: function (event) {
                }
            },
            onblur: {
                type: Function,
                default: function (event) {
                }
            },
            afterAccept: {
                type: Function,
                default: function (event) {
                }
            },
            'dataprops': {
                type: String,
                default: "",
            },
            'date_format': {
                type: String,
                default: "yyyy-MM-dd",
            },
        },
        methods: {
            keydownFn(e) {
                const modul = this;
                if (e.key === "Tab") {
                    modul.hide();
                }
                modul.keydown(e);
            },
            keyupFn(e) {
                const modul = this;
                if (e.key === "Enter") {
                    modul.accept(modul.val);
                } else if (e.key === "Escape") {
                    modul.hide();
                }
                modul.keyup(e);
            },
            handleInput (e, f, g, h) {
                if (this.isChange === "true") {
                    if (Array.isArray(this.keys) && this.keys.length === 1 && this.keys[0] === 'value') {
                        this.$emit('input', this.val)
                    } else {
                        this.$emit('input', {type: "handleInput", value: this.val, id: this.id})
                    }
                }
            },
            nplus(text) {
                console.log(text)
                if (this.isAccept === "true") {
                    if (this.id.indexOf("_numb") > -1) {
                        let id = this.id;
                        let iddefaultInput = id.replace("_numb", "");
                        const el = document.getElementById(iddefaultInput);
                        if (el && el.focus) {
                            this.visible = false;
                            el.focus();
                        }
                    }
                    if (Array.isArray(this.keys) && this.keys.length === 1 && this.keys[0] === 'value') {
                        this.$emit('input', this.val)
                    } else {
                        this.$emit('input', {type: "nplus", value: this.val, id: this.id})
                    }
                }
            },
            dbplus(text) {
                console.log(text)
                if (!this.val) {
                    return;
                }
                if (this.isAccept === "true") {
                    this.visible = false;
                    if (Array.isArray(this.keys) && this.keys.length === 1 && this.keys[0] === 'value') {
                        this.$emit('input', this.val)
                    } else {
                        this.$emit('input', {type: "dbplus", value: this.val, id: this.id})
                    }
                    this.val=""
                }
            },
            accept(text) {
                this.hide();
                if (this.isAccept === "true") {
                    if (Array.isArray(this.keys) && this.keys.length === 1 && this.keys[0] === 'value') {
                        this.$emit('input', this.val)
                    } else {
                        this.$emit('input', {type: "accept", value: this.val, id: this.id})
                    }
                }
                // need the input the first param
                const fakeInputElement={};
                fakeInputElement.target={};
                fakeInputElement.target.dataset={};
                fakeInputElement.target.dataset.props=this.dataprops;
                this.afterAccept(fakeInputElement, void 0, this.dataprops);

            },
            show(e) {
                if(this.readonly !== 'false'){return;}
                this.input = e.target;
                if (this.$i18n.locale === "hu" && e.target.dataset.layout === "t") {
                    this.layout = "hutext1";
                } else if (this.$i18n.locale === "hu" && e.target.dataset.layout === "tn") {
                    this.layout = "hutext1n";
                } else if (this.$i18n.locale === "hu" && e.target.dataset.layout === "n") {
                    this.layout = "hunum1";
                } else if (this.$i18n.locale === "hu" && e.target.dataset.layout === "nn") {
                    this.layout = "hunum1n";
                } else if (this.$i18n.locale === "hu" && e.target.dataset.layout === "nplus") {
                    this.layout = "nplus";
                } else if ((this.$i18n.locale === "en" || this.$i18n.locale === "us" || this.$i18n.locale === "ie") && e.target.dataset.layout === "t") {
                    this.layout = "normal";
                } else if ((this.$i18n.locale === "en" || this.$i18n.locale === "us" || this.$i18n.locale === "ie") && e.target.dataset.layout === "tn") {
                    this.layout = "normaln";
                } else if ((this.$i18n.locale === "en" || this.$i18n.locale === "us" || this.$i18n.locale === "ie") && e.target.dataset.layout === "n") {
                    this.layout = "num";
                } else if ((this.$i18n.locale === "en" || this.$i18n.locale === "us" || this.$i18n.locale === "ie") && e.target.dataset.layout === "nn") {
                    this.layout = "numn";
                } else if ((this.$i18n.locale === "en" || this.$i18n.locale === "us" || this.$i18n.locale === "ie") && e.target.dataset.layout === "nplus") {
                    this.layout = "nplus";
                } else if (e.target.dataset.layout === "t") {
                    this.layout = "normal";
                } else if (e.target.dataset.layout === "n") {
                    this.layout = "num";
                } else if (e.target.dataset.layout === "nplus") {
                    this.layout = "nplus";
                } else {
                    this.layout = e.target.dataset.layout;
                }
                if (!this.visible) {
                    if (this.hasToKeyboard === "auto") {
                        if (localStorage) {
                            const keyboardEnable = localStorage.getItem("keyboardEnable");
                            if (keyboardEnable === "true") {
                                this.visible = true
                            }
                        } else {
                            this.visible = false
                        }
                    } else if (this.hasToKeyboard !== "false") {
                        this.visible = true
                    }
                }
            },
            hide() {
                this.visible = false;
            }
        },
        components: {
            i18n,
//            DatetimepickerBp,
            TouchKeyboardBp,
        },
    }
</script>
<style>
    /*.vue-touch-keyboard .keyboard .key.placeholder,.vue-touch-keyboard .keyboard .key.placeholder:hover{*/
    /*border: 0 solid rgba(0, 0, 0, 0);*/
    /*color: rgba(0, 0, 0, 0);*/
    /*background-color: rgba(0, 0, 0, 0);*/
    /*box-shadow: 0 0 rgba(0, 0, 0, 0);*/
    /*cursor: default;*/
    /*}*/
</style>
<style scoped>
    .numb_alert {
        color: #dc3545;
        font-weight: bold;
        float: right;
    }

    .vue-touch-keyboard-holder-inner span.addpadding {
        height: 5px;
        display: block;
    }

    /*.vue-touch-keyboard-holder {*/
    /*display: inline-block;*/
    /*}*/
    .vue-touch-keyboard-holder.openKeyboard {
        display: block;
        left: 0;
        top: 0;
        position: fixed;
        /*padding: 130px 100px 0 100px;*/
        /*padding: 65px 50px 0 50px;*/
        z-index: 50;
        width: 100%;
        background-color: rgba(255, 255, 255, 0.8);
        height: 100%;
    }

    /*.vue-touch-keyboard .keyboard .key.placeholder {*/
    /*border: 0 solid rgba(0, 0, 0, 0);*/
    /*color: rgba(0, 0, 0, 0);*/
    /*background-color: rgba(0, 0, 0, 0);*/
    /*box-shadow: 0 0 rgba(0, 0, 0, 0);*/
    /*cursor: pointer*/
    /*}*/
    /*    .vue-touch-keyboard .keyboard .placeholder {
            flex: 20;
            height: 2.2em;
            line-height: 2.2em
        }
        .vue-touch-keyboard .keyboard .key {
            flex: 40;
            height: 2.2em;
            line-height: 2.2em;
            overflow: hidden;
            vertical-align: middle;
            text-align: center;
            white-space: nowrap;
            user-select: none;
            cursor: pointer
        }
    */
    /*.vue-touch-keyboard-background {*/
    /*background-color: red;*/
    /*}*/
</style>
